import {mandates, mandateFields, mandateDetails} from './MandateFixtures';

export default class FakeMandateService {
  getMandates() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(mandates);
      }, 0);
    });
  }

  getMandateFieldsBySubtype(subtypeCode, thirdPartyGroup = null) {
    return new Promise(resolve => {
      setTimeout(() => {
        const {fields} = mandateFields
          .find(field => field.subtypeCode === subtypeCode)
          .thirdPartyFields
          .find(field => field.thirdPartyGroup === thirdPartyGroup);
        resolve(fields);
      }, 0);
    });
  }

  getMandateDetails() {
    return Promise.resolve(mandateDetails);
  }
}
